module.exports = __webpack_public_path__ + "static/img/logoblack.ec796c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logoblack.png
// module id = 7VZT
// module chunks = 92